import { defineComponent } from "vue";
import EndControl from "../../RoomFooter/EndControl/index.mjs";
import SwitchCamera from "./SwitchCamera.vue.mjs";
import SwitchMirror from "./SwitchMirror.vue.mjs";
import SwitchAudioRoute from "./SwitchAudioRoute.vue.mjs";
import RoomInfo from "../RoomInfo/index.mjs";
import SwitchTheme from "../../common/SwitchTheme.vue.mjs";
import { isWeChat } from "../../../utils/environment.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "index",
  setup(__props) {
    return { __sfc: true, EndControl, SwitchCamera, SwitchMirror, SwitchAudioRoute, RoomInfo, SwitchTheme, isWeChat };
  }
});
export {
  _sfc_main as default
};
